import { TMentionUser } from '@onesource/schemas';
import { useEffect, useState } from 'react';
import { TiptapDoc } from './tiptap-types';
import { extractMentionIds, resolveMentionsInDoc } from './tiptap-utils';

type TFetchUsersByIds = (ids: string[]) => Promise<TMentionUser[]>;

export const useMentionResolver = (doc: TiptapDoc | null, fetchUsersByIds: TFetchUsersByIds) => {
  const [resolvedDoc, setResolvedDoc] = useState<TiptapDoc | null>(doc);

  useEffect(() => {
    if (!doc) {
      setResolvedDoc(null);
      return;
    }

    const ids = extractMentionIds(doc);

    if (ids.length === 0) {
      setResolvedDoc(doc);
      return;
    }

    fetchUsersByIds(ids).then(users => {
      const userMap = new Map(users.map(u => [u.id, u.displayName]));
      setResolvedDoc(resolveMentionsInDoc(doc, userMap));
    });
  }, [doc, fetchUsersByIds]);

  return resolvedDoc;
};
